import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './root';
import {store} from './app';
import {Provider} from 'react-redux';
import {Toaster} from 'react-hot-toast';
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <Toaster />
      <App />
    </Provider>
    <ToastContainer />
  </React.StrictMode>
);
